import axios from 'axios';
import { createErrorFromAxiosMultipleErrors } from 'api/utilities';
import { KYC_CONTACT_URL } from './constants';

export async function getKycContacts(page, size, filters = {}) {
  const { status, npwpStatus, searchBy, searchValue } = filters;
  try {
    return await axios.get(KYC_CONTACT_URL, {
      params: {
        page,
        size,
        status,
        npwp_status: npwpStatus,
        search_by: searchValue ? searchBy : undefined,
        q: searchValue || undefined,
      },
    });
  } catch (e) {
    throw createErrorFromAxiosMultipleErrors(e);
  }
}

export async function getKycContactDetail(id) {
  try {
    return await axios.get(`${KYC_CONTACT_URL}/${id}`);
  } catch (e) {
    throw createErrorFromAxiosMultipleErrors(e);
  }
}

export async function getKycContactDownloadUrl(contactId, fileId) {
  try {
    return await axios.get(
      `${KYC_CONTACT_URL}/${contactId}/files/${fileId}/url`
    );
  } catch (e) {
    throw createErrorFromAxiosMultipleErrors(e);
  }
}
